import { Logger, Presenter, type IPresenterOwner } from 'wdc-cube'
import { SearchBarScope, type Option } from './mv_scopes'

const LOG = Logger.get('MV-Presenter-SearchBar')

export type SearchBarHost = IPresenterOwner & {
    onBuscaChanged(texto: string, modo: string): Promise<void>
}

export type SearchBarConfig = {
    placeholder: string
    modos?: Option[]
    modo?: string
    aoDigitar?: boolean
}

export default class MvSearchBarPresenter extends Presenter<SearchBarScope, SearchBarHost> {
    constructor(owner: SearchBarHost, scope: SearchBarScope, config: SearchBarConfig) {
        super(owner, scope)
        this.__config = config
    }

    // :: Instance

    private readonly __config: SearchBarConfig

    private __aplicado = ''

    // :: API

    initialize() {
        const s = this.scope
        s.placeholder = this.__config.placeholder
        s.modos = this.__config.modos ?? []
        s.modo = this.__config.modo ?? ''
        s.onTextoChange = this.action(this.__handleTextoChange)
        s.onModoChange = this.action(this.__handleModoChange)
        s.onSubmit = this.action(this.__handleSubmit)
        s.onClear = this.action(this.__handleClear)
        LOG.debug('Initialized')
    }

    // :: Handlers

    private async __handleTextoChange(texto: string) {
        this.scope.texto = texto
        if (this.__config.aoDigitar) {
            await this.__aplicar(texto)
        }
    }

    private async __handleModoChange(modo: string) {
        this.scope.modo = modo
        if (this.__aplicado) {
            await this.owner.onBuscaChanged(this.__aplicado, modo)
        }
    }

    private async __handleSubmit() {
        await this.__aplicar(this.scope.texto)
    }

    private async __handleClear() {
        this.scope.texto = ''
        if (this.__aplicado) {
            await this.__aplicar('')
        }
    }

    // :: Internals

    private async __aplicar(texto: string) {
        this.__aplicado = texto.trim()
        await this.owner.onBuscaChanged(this.__aplicado, this.scope.modo)
    }
}
